import React from "react";
import "./Title.css";

const Title = () => {
  return (
    <a className="title-container" href="/">
      Maze Pathfinder
    </a>
  );
};

export default Title;
